import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/themetwo/closeGift.png'
import _imports_1 from '@/assets/themetwo/openGift.webp'


const _hoisted_1 = { class: "cardTitle" }
const _hoisted_2 = { class: "giftImage" }
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_4 = { class: "rewardAmount" }



export default /*@__PURE__*/_defineComponent({
  __name: 'checkinCard',
  props: {
    amount: {
        type: Number,
    },
    data: {
        type: Object as any
    }
},
  emits: ['getClaim'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit
const getClaim = () => {
    if (props.data.active && props.data.status == 0) {
        emits('getClaim')
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "card",
    style: _normalizeStyle({
        backgroundImage: __props.data.active ? 'linear-gradient(45deg, rgb(24 106 48 /40%), rgb(143 217 39/40%))'
            : __props.data.status === 0 && !__props.data.active ? ''
                : __props.data.status === 1 && !__props.data.active ? 'linear-gradient(45deg, rgb(22 49 134/40%), rgb(40 167 164/40%))'
                    : __props.data.status === 2 || __props.data.status === 3 ? 'linear-gradient(45deg, rgb(89 7 34 / 40%), rgb(235 1 1 / 40%))' : ''
    }),
    onClick: getClaim
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('common.travel')) + " " + _toDisplayString(__props.data.day), 1),
    _createElementVNode("div", _hoisted_2, [
      (__props.data.status !== 1)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            style: _normalizeStyle({ opacity: !__props.data.active ? '0.5' : '1' }),
            class: _normalizeClass(__props.data.active ? 'chest-animate' : ''),
            src: _imports_0,
            alt: ""
          }, null, 6))
        : (_openBlock(), _createElementBlock("img", _hoisted_3))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { style: {"font-size":"12px","color":"orange","font-weight":"300","padding":"0 5px"} }, "R$", -1)),
      _createTextVNode(_toDisplayString(__props.data.status == 1 || __props.data.status == 2 ? __props.data.amount : __props.amount), 1)
    ])
  ], 4))
}
}

})